var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 4.125H4.8125C4.4328 4.125 4.125 4.4328 4.125 4.8125V8.9375C4.125 9.3172 4.4328 9.625 4.8125 9.625H8.9375C9.3172 9.625 9.625 9.3172 9.625 8.9375V4.8125C9.625 4.4328 9.3172 4.125 8.9375 4.125Z",
    stroke: "#73777F",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 12.375H4.8125C4.4328 12.375 4.125 12.6828 4.125 13.0625V17.1875C4.125 17.5672 4.4328 17.875 4.8125 17.875H8.9375C9.3172 17.875 9.625 17.5672 9.625 17.1875V13.0625C9.625 12.6828 9.3172 12.375 8.9375 12.375Z",
    stroke: "#73777F",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 4.125H13.0625C12.6828 4.125 12.375 4.4328 12.375 4.8125V8.9375C12.375 9.3172 12.6828 9.625 13.0625 9.625H17.1875C17.5672 9.625 17.875 9.3172 17.875 8.9375V4.8125C17.875 4.4328 17.5672 4.125 17.1875 4.125Z",
    stroke: "#73777F",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 12.375V15.125",
    stroke: "#73777F",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 17.875H15.125V12.375",
    stroke: "#73777F",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 13.75H17.875",
    stroke: "#73777F",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 16.5V17.875",
    stroke: "#73777F",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/QrCode.7d66a432bef620c220948e3e44c48ce0.svg";
export { ForwardRef as ReactComponent };